import { type RequestContext } from '@cx-web/domain-types';

import { type BettingInsightsResultAttribute, type EsIndex } from '../types';

import { type BettingInsightsFilterConfiguration, createBettingInsightsFilter } from './BettingInsightsFilter';
export interface BettingInsightsRefinementsConfig<TIndex extends EsIndex> {
  clearAll: {
    excludedAttributes: BettingInsightsResultAttribute<TIndex>[];
  };
  components: BettingInsightsFilterConfiguration<TIndex>[];
}

/**
 * Factory function to create BettingInsightsRefinements configuration (functional approach)
 * @param requestContext - The request context
 * @param config - The refinements configuration
 * @returns Immutable refinements configuration object
 */
export function createBettingInsightsRefinements<TIndex extends EsIndex>(
  requestContext: RequestContext,
  config: BettingInsightsRefinementsConfig<TIndex>,
) {
  return Object.freeze({
    // Context properties
    environment: requestContext.environment,
    featureFlags: requestContext.featureFlags,
    repubConfig: requestContext.repubConfig,
    user: requestContext.user,

    // Config properties
    clearAll: config.clearAll,
    components: config.components.map(filter => createBettingInsightsFilter(requestContext, filter)),
  });
}
